module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 014.c7be2416.jpg";